export function asEntityId(value) {
  if (value == null || value === '') return '';
  if (typeof value === 'object') return String(value.id ?? value._id ?? '');
  return String(value);
}

export function sameEntityId(a, b) {
  const left = asEntityId(a);
  const right = asEntityId(b);
  return !!left && left === right;
}

export function pinnedIdSetFrom(ids) {
  return new Set((ids || []).map(asEntityId).filter(Boolean));
}
